import React, { Component } from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import {
  // SamplePage, 
  ItemsPage, ItemSelectPage, PlusUpPage,
  MainPage,
  WowFindPage, WowBisPage, FinancePage,
  SimcPage
} from 'pages';
import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./common/ScrollToTop";

// import ReactGA from 'react-ga';
// ReactGA.initialize('UA-123320555-1');

class App extends Component {
  
  

  // logPageView = () => {
  //   ReactGA.set({ page: window.location.pathname });
  //   ReactGA.pageview(window.location.pathname);
  //   return null;  
  // }

  render() {
    // this.logPageView();

    return (
      <div>
        <HelmetProvider>
        <Helmet>
          <title>이터인포 - 한국형 좀비 아포칼립스 RPG! 이터널시티의 모든 정보</title>
        </Helmet>
        </HelmetProvider>
        <ScrollToTop/>
        <Routes>
          <Route path="/" element={<MainPage/>} />
          <Route path="/wp" element={<Navigate to="/item"/>}/>
          <Route path="/wp/:id" element={<Navigate to="/item"/>}/>
          <Route path="/item" element={<ItemsPage/>} />
          <Route path="/item/:id" element={<ItemSelectPage/>} />
          <Route path="/plusup" element={<PlusUpPage/>} />
          <Route path="/wow" element={<WowFindPage/>} />
          <Route path="/wowbis" element={<WowBisPage/>} />
          <Route path="/finance" element={<FinancePage/>} />
          <Route path="/finance/:id" element={<FinancePage/>} />

          <Route path="/simc" element={<SimcPage/>} />
          {/* <Route path="/custom" element={<CustomMainPage/>}/>
          <Route path="/custom/dmg" element={<DmgCustomPage/>}/>
          <Route path="/custom/dmg/:id" element={<DmgCustomPage/>}/> */}
        </Routes>
      </div>
    );
  }
}

export default App;